

















export default {
  props: {
    open: Boolean,
  },
  data() {
    return {
      showModal: this.open,
    };
  },
  methods: {},
  watch: {
    open(value) {
      this.showModal = value;
    },
  },
};
